var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "pittan" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/アセット 64@3x.png") },
        on: { click: _vm.openModal }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showContent,
            expression: "showContent"
          }
        ],
        staticClass: "overlay"
      },
      [
        _c("img", {
          staticClass: "confirm-bg",
          attrs: { src: require("@/assets/img/アセット 80@3x.png") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "confirm-msg",
          attrs: { src: require("@/assets/img/アセット 81@3x.png") }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "confirm-yes",
          attrs: { src: require("@/assets/img/アセット 82@3x.png") },
          on: { click: _vm.submission }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "confirm-no",
          attrs: { src: require("@/assets/img/アセット 83@3x.png") },
          on: { click: _vm.closeModal }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.pittanMedal,
            expression: "pittanMedal"
          }
        ],
        staticClass: "first-success overlay"
      },
      [
        _vm.medal_type === "gold"
          ? _c("img", {
              staticClass: "medal-style",
              attrs: { src: require("@/assets/img/アセット 87@3x.png") }
            })
          : _vm.medal_type === "silver"
          ? _c("img", {
              staticClass: "medal-style",
              attrs: { src: require("@/assets/img/アセット 85@3x.png") }
            })
          : _c("img", {
              staticClass: "medal-style",
              attrs: { src: require("@/assets/img/アセット 86@3x.png") }
            })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mistakeactive,
            expression: "mistakeactive"
          }
        ],
        staticClass: "mistake-msg"
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.downArrow1,
              expression: "downArrow1"
            }
          ],
          staticClass: "down-arrow1",
          attrs: { src: require("@/assets/img/アセット 84@3x.png") }
        }),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.downArrow2,
              expression: "downArrow2"
            }
          ],
          staticClass: "down-arrow2",
          attrs: { src: require("@/assets/img/アセット 84@3x.png") }
        }),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.downArrow3,
              expression: "downArrow3"
            }
          ],
          staticClass: "down-arrow3",
          attrs: { src: require("@/assets/img/アセット 84@3x.png") }
        }),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.downArrow4,
              expression: "downArrow4"
            }
          ],
          staticClass: "down-arrow4",
          attrs: { src: require("@/assets/img/アセット 84@3x.png") }
        })
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("矢印の箇所が間違っています。"),
      _c("br"),
      _vm._v("もう一度やってみましょう！")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-82f47554", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82f47554","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PittanBtn.vue
// module id = null
// module chunks = 